import { useState, useEffect, useRef } from "react";
import "./SearchableSelect.css";

export default function SearchableSelect({ options = [], value, onChange, placeholder = "-- Select --", required = false }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const containerRef = useRef();
  const inputRef = useRef();

  const selected = options.find(o => String(o.id) === String(value));

  const filtered = query.trim()
    ? options.filter(o => o.name.toLowerCase().includes(query.toLowerCase()))
    : options;

  useEffect(() => {
    const handler = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setQuery("");
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const handleSelect = (opt) => {
    onChange(opt.id);
    setOpen(false);
    setQuery("");
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange("");
    setOpen(false);
    setQuery("");
  };

  return (
    <div className="ss-container" ref={containerRef}>
      <div
        className={`ss-trigger ${open ? "ss-open" : ""} ${required && !value ? "ss-required" : ""}`}
        onClick={handleOpen}
      >
        <span className={selected ? "ss-value" : "ss-placeholder"}>
          {selected ? selected.name : placeholder}
        </span>
        <span className="ss-icons">
          {value && <span className="ss-clear" onClick={handleClear}>×</span>}
          <span className="ss-arrow">{open ? "▲" : "▼"}</span>
        </span>
      </div>

      {open && (
        <div className="ss-dropdown">
          <input
            ref={inputRef}
            className="ss-search"
            placeholder="Type to search..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Escape") { setOpen(false); setQuery(""); }
              if (e.key === "Enter" && filtered.length === 1) handleSelect(filtered[0]);
            }}
          />
          <div className="ss-list">
            {filtered.length === 0
              ? <div className="ss-empty">No results</div>
              : filtered.slice(0, 200).map(opt => (
                  <div
                    key={opt.id}
                    className={`ss-option ${String(opt.id) === String(value) ? "ss-selected" : ""}`}
                    onMouseDown={() => handleSelect(opt)}
                  >
                    {opt.name}
                  </div>
                ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
